import { Box, Modal } from '@mui/material';
import React, { useState } from 'react';

interface ImageRendererProps {
  url: string;
}

function ImageRenderer({ url }: ImageRendererProps): React.ReactNode {
  const [isFullscreen, setIsFullscreen] = useState(false);

  console.log('ImageRenderer', url);
  const handleOpen = () => setIsFullscreen(true);
  const handleClose = () => setIsFullscreen(false);

  return (
    <Box>
      <img
        src={url}
        alt="content"
        onClick={handleOpen}
        style={{
          maxWidth: '100%',
          maxHeight: '100%',
          objectFit: 'contain',
          cursor: 'pointer',
        }}
      />

      <Modal
        open={isFullscreen}
        onClose={handleClose}
        aria-labelledby="fullscreen-image"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            maxWidth: '90vw',
            maxHeight: '90vh',
            outline: 'none',
          }}
        >
          <img
            src={url}
            alt="content-fullscreen"
            style={{
              maxWidth: '100%',
              maxHeight: '90vh',
              objectFit: 'contain',
            }}
            onClick={handleClose}
          />
        </Box>
      </Modal>
    </Box>
  );
}

export default ImageRenderer;
